import { result } from "../routes";
const getTeamsResult = async (team) => {
  try {
    const response = await fetch(result.getTeamsResult, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      body: JSON.stringify({
        event: "minigameVhu30",
        team1: team,
      }),
    });
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Request failed:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const getTopResultOfTeam = async () => {
  try {
    const response = await fetch(result.getTopResultOfTeam, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      body: JSON.stringify({}),
    });
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Request failed:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

const getTop10Result = async (data) => {
  try {
    const response = await fetch(result.getTop10Result, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
      },
      body: JSON.stringify({
        event: "minigameVhu30",
        ...data,
      }),
    });
    if (response.ok) {
      const result = await response.json();
      return result;
    } else {
      console.error("Request failed:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export { getTeamsResult, getTopResultOfTeam, getTop10Result };
